import React, {useEffect, useRef, useState} from 'react';
import {postToHub} from "../../actions/networkActions";
import usePreCruisePassenger from "../../hooks/usePreCruisePassenger";
import BackLink from "../../components/BackLink";
import PinInput from "../../components/passengerInformation/PinInput";
import {isPinValid} from "../../utils/miscUtils";
import { Trans, useLingui } from '@lingui/react/macro';
import { navigate } from '../../utils/navigationUtils';

function PassengerUnlockByOtp(props) {
    const [pin, setPin] = useState(["","","","","",""]);
    const [error, setError] = useState("");
    const [isOtpsent, setIsOtpSent] = useState(false);
    const [email, setEmail] = useState("");
    const {t} = useLingui();

    const {passengerId, type} = props.params;
    const {firstName, lastName, travelInfoStatus, prerequisiteQuestionnaireStatus} = usePreCruisePassenger(passengerId);

    const name = `${firstName} ${lastName}`;
    const isCCPage = type === "cc";
    const isMedicalMobilityPage = type === "medicalAndMobility";

    useEffect(()=>{
        const sendOtp = async () => {
            const url = "precruise/passenger/otp";

            const successCallback = (response) => {
                setIsOtpSent(true);
                setEmail(response.email);
            }

            const errorCallback = () => {setIsOtpSent(false)}

            await await postToHub(url, {passengerId}, successCallback, errorCallback );
        }
        if(!isOtpsent){
            sendOtp();
        }
    },[]);

    if(!isOtpsent) {
        return (<div className="container mx-auto mt-12">
            <span><Trans id="sending_otp">Sending One Time Password (OTP)</Trans>...</span>
        </div>)
    }

    const pinValid = isPinValid(pin);

    async function submit() {
        if(!isPinValid(pin)) {
            setError(t({id: "please_enter_otp"}));
            return;
        }

        await postToHub(
            {path: 'precruise/passenger/otp/validate', logoutOn403: false},
            {passengerId, otp: pin.join("")},
            successCallback,
            errorCallback
        );


        function successCallback(){
            let url = isCCPage ?
                t({id: "/precruise/passenger"}) + `/${passengerId}/cc` :
                t({id: "/precruise/passenger"}) + `/${passengerId}` + t({id: "/review"}) + `${isMedicalMobilityPage ? "/medicalAndMobility" : ""}`;

            if(isMedicalMobilityPage && prerequisiteQuestionnaireStatus !== "COMPLETE"){
                url = t({id: "/precruise/passenger"}) + `/${passengerId}` + "/medicalAndMobility"
            }
            
            if(!isCCPage && !isMedicalMobilityPage && travelInfoStatus !== "COMPLETE"){
                url = t({id: "/precruise/passenger"}) + `/${passengerId}`
            }
            navigate(url);
        }

        function errorCallback({response}){
            if(response?.status === 403) {
                setError(t({id: "invalid_otp"}));
            }
            else {
                setError(t({id: "unexpected_error_happened_try_again"}));
            }
        }
    }

    const pageType = isMedicalMobilityPage 
    ? "/medicalAndMobility" 
    : isCCPage 
        ? "/cc" 
        : "";

    const backLink = t({id: '/precruise/passengers'}) + pageType;
    const backLinkText = isMedicalMobilityPage
    ? t({id: "back_to_medical_and_mobility_information_dashboard"})
    : isCCPage
        ? t({id: "back_to_card_registration_dashboard"})
        : t({id: "back_to_travel_information_dashboard"});


    return (
        <div className="container mx-auto">
            <div className="mt-4">
                <BackLink to={backLink} text={backLinkText} />
            </div>

            <h1 className="my-6">
                {isMedicalMobilityPage ? (
                    <Trans id="m_and_m_information_for">Medical and Mobility Information for</Trans>
                ) : (
                    <Trans id="travel_information_for">Travel Information for</Trans>
                )}
                {' '} {name}
            </h1>

            <div className="my-4">
                <Trans id="information_for_pax_is_locked">The information for {name} is locked.</Trans>
            </div>

            {isOtpsent ? (
                <div className="bg-grey-lightest-2 border p-4 mt-6">
                    <Trans id="otp_sent_successfully_please_input">
                        <div>
                            One Time Password (OTP) sent successfully to {email}.
                        </div>
                        <div className="mt-2 text-sm">
                            Please input the OTP to review or edit your Information.
                        </div>
                    </Trans>

                    <PinInput
                        autoFocus={true}
                        pin={pin}
                        setPin={setPin}
                        submit={submit}
                        idPrefix="pin"
                    />

                    <Trans id="otp_issue_contact_guest_services_text">
                        <div className='mt-2'>
                            One Time Password not received? Please check your email junk folders and if not received please contact Guest Services.
                        </div>

                        <div className="mt-2">
                            If you no longer have access to the email account used to lock your details, please contact guest services.
                        </div>
                    </Trans>
                </div>
            ) : (
                <div className="bg-grey-lightest-2 border p-4 mt-6">
                    <p className='mr-4'>
                        <Trans id="error_sending_otp">There has been an error sending the One Time Password (OTP).</Trans>
                    </p>
                    <button className='cursor-pointer border-2 py-2 px-4 rounded uppercase tracking-wide text-sm' onClick={retry}>
                        <Trans id="resend">Resend</Trans>
                    </button>
                </div>
            )}



            {error &&
            <div className="mt-4 text-red">
                {error}
            </div>}

            <div className="mt-6 mb-8">
                <button className={`action-button w-mobile ${pinValid ? "action-button-enabled" : "action-button-disabled"}`}
                        onClick={submit}>
                    <Trans id="next">Next</Trans>
                </button>
            </div>
        </div>
    );
}

export default PassengerUnlockByOtp;